.card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  overflow: hidden;

  &:hover .posterFade,
  &:hover .removeSlot,
  &:hover .customizeSlot {
    opacity: 1;
  }
}

.poster {
  position: relative;
  aspect-ratio: 4 / 5;
  overflow: hidden;
  background: var(--dark-3);

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.placeholder {
  width: 100%;
  height: 100%;
  background: var(--dark-4);
}

.posterFade {
  position: absolute;
  inset: auto 0 0;
  height: 42%;
  pointer-events: none;
  background: linear-gradient(to top, rgb(255 255 255 / 55%), transparent);
  backdrop-filter: blur(3px);
  -webkit-mask-image: linear-gradient(to top, #000 30%, transparent);
  mask-image: linear-gradient(to top, #000 30%, transparent);
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.pillCorner {
  position: absolute;
  top: 8px;
  left: 8px;
}

.removeSlot {
  position: absolute;
  top: 12px;
  right: 12px;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.customizeSlot {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
}

.playButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgb(0 0 0 / 60%);
  color: var(--white);
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--white);
    outline-offset: 2px;
  }
}
